// src/components/Departments.jsx
import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DepartmentCard from "./DepartmentCard";

// Import images
import civilImg from "../assets/images/civil.webp";
import sewerageImg from "../assets/images/swearage.webp";
import elect1Img from "../assets/images/elect1.webp";
import elect2Img from "../assets/images/elect2.webp";
import roadImg from "../assets/images/l.webp";
import waterImg from "../assets/images/water.webp";
import cctvImg from "../assets/images/cctv.webp";
import tradeImg from "../assets/images/trade.webp";

const departments = [
  { id: 1, title: "Civil Works", description: "Specializing in large-scale civil construction projects including roads, bridges, and public infrastructure development across Bahrain.", image: civilImg },
  { id: 2, title: "Sewerage & Drainage", description: "At the Sewerage & Drainage Directorate as an AA class Contractor's we do drainage schemes, Micro Tunneling, manholes, septic tanks, main sewers, storm water drains, aeration tanks, mechanical maintenance, sewerage pumps repair and maintenance.", image: sewerageImg },
  { id: 3, title: "Electro-Mechanical", description: "Comprehensive electro-mechanical solutions for pumping stations, including installation, maintenance, and modernization services.", image: elect1Img },
  { id: 4, title: "Electrical Infrastructure", description: "Full-spectrum electrical services from cabling and substations to street lighting and traffic management systems.", image: elect2Img },
  { id: 5, title: "Road & Traffic Solutions", description: "Innovative road marking, guard rail installation, and traffic sign solutions enhancing Bahrain's transportation safety.", image: roadImg },
  { id: 6, title: "Water Distribution Directorate Works", description: "We do lay of water mains, water distribution networks, house connections, fixing of water meters and all associated works, we undertake fencing, boundary walls and all types of Civil Engineering works.", image: waterImg },
  { id: 7, title: "CCTV Inspection Works", description: "We have a specialized service of underground pipe CCTV inspection, Jetting Cleaning and Spot Repairing works, to inspect damage or leaks, blockages and repairing works in pipes and manholes.", image: cctvImg },
  { id: 8, title: "Trading", description: "We have also our own division Al Afoo Trading, which includes the supply of manhole cover and frames, DI gully grates, as we are the main stockiest and distributors of brand names.", image: tradeImg },
];

// Helper to import all images
const importAll = (r) => r.keys().map(r);

// Slideshow
const Slideshow = () => {
  const [images, setImages] = useState([]);
  const [index, setIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const imageContext = require.context(
        "../../public/models",
        false,
        /\.(webp|png|jpg|jpeg)$/
      );
      setImages(importAll(imageContext));
      setIsLoading(false);
    } catch (error) {
      console.error("Error loading images:", error);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [images.length]);

  const goToPrev = () => setIndex((prev) => (prev - 1 + images.length) % images.length);
  const goToNext = () => setIndex((prev) => (prev + 1) % images.length);

  if (isLoading) {
    return (
      <div className="slideshow-container">
        <div className="slideshow-loading">
          <div className="loading-spinner"></div>
          <p>Loading images...</p>
        </div>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="slideshow-container">
        <div className="slideshow-empty">
          <p>No images found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="slideshow-container">
      <div className="slideshow-wrapper">
        <AnimatePresence mode="wait">
          <motion.div
            key={images[index]}
            className="slide-item"
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.7 }}
          >
            <img
              src={images[index]}
              alt="Slideshow"
              className="slide-image"
            />
          </motion.div>
        </AnimatePresence>

        {images.length > 1 && (
          <>
            <button onClick={goToPrev} className="slideshow-nav slideshow-nav-prev">
              ‹
            </button>
            <button onClick={goToNext} className="slideshow-nav slideshow-nav-next">
              ›
            </button>
          </>
        )}

        {images.length > 1 && (
          <div className="slideshow-indicators">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`indicator ${i === index ? "active" : ""}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Departments = () => {
  const [selectedDept, setSelectedDept] = useState(null);
  const sectionRef = useRef();

  return (
    <section id="departments" ref={sectionRef} className="departments-section">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ root: sectionRef }}
        transition={{ duration: 1 }}
        className="container"
      >
        <h2 className="section-title">Our Specialized Departments</h2>
        <p className="section-intro">
          ABDULHADI AL-AFOO W.L.L comprises multiple specialized divisions
          working in harmony to deliver comprehensive infrastructure solutions
          throughout the Kingdom of Bahrain.
        </p>

        <Slideshow />

        <div className="departments-grid">
          {departments.map((dept, index) => (
            <DepartmentCard
              key={dept.id}
              department={dept}
              index={index}
              isSelected={selectedDept?.id === dept.id}
              onSelect={setSelectedDept}
            />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Departments;
